<template>
  <div class="manage-posts">
    <el-row type="flex" align="middle" class="page-title">
      <i class="el-icon-menu mr-s" />
      <h3>{{ $route.params.id ? "Cập nhật bài viết" : "Tạo mới bài viết" }}</h3>
    </el-row>
    <el-row class="content">
      <el-col :span="24" :lg="20">
        <el-card shadow="never">
          <el-form :model="form" ref="form" :rules="rules">
            <el-form-item label="Tên" prop="name">
              <el-input
                v-model="form.name"
                :disabled="callingAPI"
                @input="handleGenerateSlug"
                placeholder="Tên bài viết"
              />
            </el-form-item>
            <el-form-item label="Slug" prop="slug">
              <el-input v-model="form.slug" />
            </el-form-item>
            <el-form-item label="Tác giả" prop="author">
              <el-input
                v-model="form.author"
                :disabled="callingAPI"
                placeholder="Tên tác giả"
              />
            </el-form-item>
            <el-form-item label="Danh mục" prop="category">
              <el-input-number
                v-model="form.category_id"
                :disabled="callingAPI"
                placeholder="Nhập danh mục"
              />
            </el-form-item>
            <el-form-item label="Ngày xuất bản bài viết" prop="publishedAt">
              <el-date-picker
                v-model="form.publishedAt"
                class="w-full"
                type="date"
                placeholder="Chọn ngày xuất bản"
              />
            </el-form-item>
            <el-form-item label="Mô tả" prop="description">
              <el-input
                type="textarea"
                :rows="3"
                v-model="form.description"
                :disabled="callingAPI"
                placeholder="Mô tả"
              />
            </el-form-item>
            <el-form-item label="Ảnh đại diện" prop="avatar">
              <input
                type="file"
                accept="image/png, image/jpeg, image/jpg, image/gif"
                @change="onAvatarChange"
              />
              <img
                v-show="currentAvatar || avatarUrl"
                id="preview-avatar"
                :src="avatarUrl"
                class="preview-avatar"
              />
            </el-form-item>
            <el-form-item label="Nội dung" prop="content">
              <div class="markdown-editor">
                <mavon-editor
                  language="en"
                  :subfield="false"
                  v-model="form.content"
                  ref="md"
                  @imgAdd="imgAdd"
                />
              </div>
            </el-form-item>
            <el-form-item label="Tags" prop="tags">
              <div style="display: inline-block">
                <el-row type="flex" align="middle">
                  <el-tag
                    :key="tag"
                    v-for="tag in form.tags"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)"
                    class="mr-m"
                  >
                    {{ tag }}
                  </el-tag>
                  <el-input
                    class="input-new-tag"
                    v-if="inputTagVisible"
                    v-model="inputTag"
                    ref="saveTagInput"
                    size="mini"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                  >
                  </el-input>
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="showInput"
                  >
                    + New Tag
                  </el-button>
                </el-row>
              </div>
            </el-form-item>
            <el-form-item label="SEO title">
              <el-input
                v-model="form.metaTitle"
                :disabled="callingAPI"
                placeholder="SEO title"
              />
            </el-form-item>
            <el-form-item label="SEO keyword">
              <el-input
                v-model="form.metaKeyword"
                :disabled="callingAPI"
                placeholder="SEO keyword"
              />
            </el-form-item>
            <el-form-item label="SEO description">
              <el-input
                v-model="form.metaDescription"
                :disabled="callingAPI"
                placeholder="SEO description"
              />
            </el-form-item>
          </el-form>
          <el-row type="flex" justify="end" class="mt-xl">
            <el-button
              class="mt-xl"
              type="primary"
              :loading="callingAPI"
              @click="handleManage"
            >
              {{ $route.params.id ? "Cập nhật" : "Tạo mới" }}
            </el-button>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { upload } from "@/services/storage";
import { createPosts, updatePosts, fetchPostsById } from "@/services/posts";
import { convertDate } from "@/utils/filters";
import ENDPOINT from "@/config/endpoint";
import { replaceUrlResourceBlog } from "@/utils/common";

const slugify = require("slugify");

export default {
  name: "CreateUpdatePosts",
  data() {
    return {
      markdownOption: {
        language: "en",
      },

      callingAPI: false,

      inputTagVisible: false,
      inputTag: "",

      form: {
        name: "",
        slug: "",
        author: "",
        category_id: "",
        publishedAt: "",
        description: "",
        content: "",
        photo_url_path: "",
        tags: [],
        metaTitle: "",
        metaKeyword: "",
        metaDescription: "",
        status: 1,
        head_new: null,
      },
      rules: {
        name: [
          {
            required: true,
            message: "Giá trị không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        author: [
          {
            required: true,
            message: "Giá trị không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        category_id: [
          {
            required: true,
            message: "Giá trị không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        publishedAt: [
          {
            required: true,
            message: "Giá trị không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        description: [
          {
            required: true,
            message: "Giá trị không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        content: [
          {
            required: true,
            message: "Giá trị không được để trống",
            trigger: ["blur", "change"],
          },
        ],
      },

      currentAvatar: null,
      avatarUrl: "",
    };
  },
  async beforeMount() {
    if (this.$route.params.id) {
      await this.loadData();
    }
  },
  methods: {
    imgAdd(pos, $file) {
      const formdata = new FormData();
      formdata.append("upload", $file);
      formdata.append("type", "posts");
      upload(formdata).then((res) => {
        this.$refs.md.$img2Url(
          pos,
          res?.data?.length ? `${ENDPOINT.BACKEND_URL}${res.data[0].path}` : ""
        );
      });
    },
    handleClose(tag) {
      this.form.tags.splice(this.form.tags.indexOf(tag), 1);
    },

    showInput() {
      this.inputTagVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputTag = this.inputTag;
      if (inputTag) {
        this.form.tags.push(inputTag);
      }
      this.inputTagVisible = false;
      this.inputTag = "";
    },

    async loadData() {
      this.callingAPI = true;
      const response = await fetchPostsById(this.$route.params.id);
      let d = response.data.published_at.split("/");
      let publishedDate = new Date(d[2] + "/" + d[1] + "/" + d[0]);

      this.form.name = response.data.name;
      this.form.slug = response.data.slug;
      this.form.author = response.data.author;
      this.form.category_id =
        response.data.category_name || response.data.category_id; // Adjust based on backend response
      this.form.publishedAt = new Date(publishedDate);
      this.form.description = response.data.description;
      this.form.content = response.data.content;
      this.form.photo_url_path = response.data.photo_url_path;
      this.form.metaTitle = response.data.meta_title;
      this.form.metaDescription = response.data.meta_description;
      this.form.metaKeyword = response.data.meta_keyword;
      this.form.tags = response.data.post_tags.map((t) => t.name);
      this.form.head_new = response.data.head_new;

      this.avatarUrl = replaceUrlResourceBlog(response.data.photo_url_path);

      this.callingAPI = false;
    },
    onAvatarChange(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        console.log("Selected file:", file);
        this.currentAvatar = file;
        this.avatarUrl = URL.createObjectURL(file);
      } else {
        console.log("No file selected");
      }
    },
    handleGenerateSlug() {
      this.form.slug = slugify(this.form.name);
    },
    async handleUploadAvatar() {
        let formDataAvatar = new FormData();
        formDataAvatar.append("upload", this.currentAvatar);
        formDataAvatar.append("type", "posts");
        try {
            const responseAvatar = await upload(formDataAvatar);
            console.log("Upload response:", JSON.stringify(responseAvatar, null, 2));
            if (responseAvatar.status !== 1 || !responseAvatar.data?.length) {
                throw new Error(responseAvatar.errors?.[0] || "Lỗi tải ảnh lên, kiểm tra quyền thư mục hoặc cấu hình server.");
            }
            this.form.photo_url_path = responseAvatar.data[0].path;
            console.log("Photo URL path:", this.form.photo_url_path);
        } catch (error) {
            console.error("Upload error:", error);
            throw new Error("Lỗi tải ảnh lên: " + error.message);
        }
    },
    async handleManage() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          console.log("Current avatar:", this.currentAvatar);
          try {
            this.callingAPI = true;

            if (this.currentAvatar) {
              await this.handleUploadAvatar();
              if (!this.form.photo_url_path) {
                throw new Error("Lỗi tải ảnh lên, không thể tiếp tục tạo bài viết.");
              }
            }

            const data = {
              name: this.form.name,
              slug: this.form.slug,
              author: this.form.author,
              category_id: Number(this.form.category_id),
              published_at: convertDate(this.form.publishedAt, "DD/MM/YYYY"),
              description: this.form.description,
              content: this.form.content,
              photo_url_path: this.form.photo_url_path || null,
              meta_title: this.form.metaTitle,
              meta_description: this.form.metaDescription,
              meta_keyword: this.form.metaKeyword,
              tags: JSON.stringify(this.form.tags),
              head_new: null,
            };

            let response = null;
            if (this.$route.params.id) {
              response = await updatePosts(this.$route.params.id, data);
            } else {
              response = await createPosts(data);
            }

            this.callingAPI = false;
            if (response.status == 1) {
              const message = this.$route.params.id
                ? "Cập nhật bài viết thành công."
                : "Thêm bài viết thành công.";
              this.$notify.success({
                title: "Thành công",
                message: message,
                duration: 2000,
              });
              this.$router.push({ name: "ManagePosts" });
            } else {
              throw new Error(response.errors?.[0] || "Lỗi không xác định");
            }
          } catch (error) {
            this.callingAPI = false;
            this.$notify.error({
              title: "Thất bại",
              message: error.message || "Thêm/Cập nhật bài viết thất bại.",
              duration: 2000,
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#preview-avatar {
  max-width: 100%;
  object-fit: contain;
  display: block;
}
#audio {
  display: block;
  margin-top: 15px;
}
.markdown-editor {
  display: inline-block;
  width: 100%;
  .v-note-wrapper {
    min-height: 500px;
    z-index: 1;
  }
}
</style>
